import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, getCurrentInstance } from 'vue';
import { add } from '@white-label-helper/date-utilities';
import { DateRangePicker } from 'feature-shared-organisms';


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-form-step-2',
  props: {
    startDate: { default: '' },
    endDate: { default: '' },
    inlineDatePicker: { type: Boolean, default: true }
  },
  emits: ["goBack", "update:dateRangePickerOpen", "update:value", "input-start-date", "input-end-date"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'goBack'): void;
  (e: 'update:dateRangePickerOpen', val: boolean): void;
  (e: 'update:value', val: { startDate: Date | string; endDate: Date | string }): void;
  (e: 'input-start-date', val: Date | string): void;
  (e: 'input-end-date', val: Date | string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { startDate: Date | string, endDate: Date | string, inlineDatePicker: boolean };

const instance = getCurrentInstance();
const proxy = instance?.proxy as Vue;





// Properties to manipulate the date picker
const dateRangePickerOpen = ref(false);
const openDatePicker = () => {
  dateRangePickerOpen.value = true;
  emit('update:dateRangePickerOpen', true);
};
const closeDatePicker = () => {
  dateRangePickerOpen.value = false;
  emit('update:dateRangePickerOpen', false);
}

const showTitle = computed(() => {
  if (!props.inlineDatePicker) return true;
  return !dateRangePickerOpen.value;
});

// Show a regulatory message if the start date is today and the datepicker is closed.
const showSameDayMessage = computed(() => {
  if (!props.startDate || dateRangePickerOpen.value) return false;
  return new Date(props.startDate).toDateString() === new Date().toDateString();
})

// Restrict trip start date to at most 365 days from today.
const calculatedMaxDate = computed(() => {
  return add(new Date(), { days: 364 });
});

// Whether the form has been touched
const dirty = ref<boolean>(false);

// Whether the current form state is valid
const isValid = computed(() => {
  return !!(props.startDate && props.endDate);
})

// Whether we should show an error message
const showError = computed(() => {
  return dirty.value && !isValid.value && !dateRangePickerOpen.value;
})

// Computed error messages for each date range input
const dateRangeErrors = computed (() => {
  const errors: { startDate: string; endDate: string } = {
    startDate: '',
    endDate: '',
  };
  if (showError.value) {
    if (!props.startDate) {
      errors.startDate = proxy.$t('searchExtras.travelInsurance.errorMsg.startDate') as string;
    }
    if (!props.endDate) {
      errors.endDate = proxy.$t('searchExtras.travelInsurance.errorMsg.endDate') as string;
    }
  }
  return errors;
})

// Sets form state to dirty in order to show error messages
const validateForm = () => {
  dirty.value = true;
}

// Sets form state to dirty and emits updated value
const updateValue = (dates: { startDate: Date | string; endDate: Date | string }) => {
  dirty.value = true;
  emit('update:value', dates);
}

expose({
  isValid,
  validateForm,
})

return { __sfc: true,instance, proxy, props, emit, dateRangePickerOpen, openDatePicker, closeDatePicker, showTitle, showSameDayMessage, calculatedMaxDate, dirty, isValid, showError, dateRangeErrors, validateForm, updateValue, DateRangePicker }
}

})